'use strict';

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({
    startEvent: 'DOMContentLoaded',
    delay: 200,
    offset: 80
  });

  const headerMenu = document.querySelector('.site-header__menu');
  const menuItems = document.querySelectorAll('.site-header__menu a');
  const menuLink = document.querySelector('.site-header__menu-link');

  menuLink.addEventListener('click', function (e) {
    e.preventDefault();

    menuLink.classList.toggle('site-header__menu-link--active');
    headerMenu.classList.toggle('site-header__menu--active');
  });

  menuItems.forEach((item) => item.addEventListener('click', function (e) {
    headerMenu.classList.remove('site-header__menu--active');
    menuLink.classList.remove('site-header__menu-link--active');
  }));
});
